import { Col, Tabs, TabsProps } from "antd";
import { GetDealType } from "../../ducks/types";
import TabCheckList from "./GeneralDetails/TabCheckList";
import TabDetails from "./GeneralDetails/TabDetails";
import TabActivity from "./GeneralDetails/TabActivity";

interface PropsType {
  sidebarData: GetDealType | null;
}

export default function DealsSidebar(props: PropsType) {
  const { sidebarData } = props;
  const GeneralDetailTabs: TabsProps["items"] = [
    {
      key: "1",
      label: "Details",
      children: <TabDetails sidebarData={sidebarData} />,
    },
    {
      key: "2",
      label: "Checklist",
      children: <TabCheckList />,
    },
    {
      key: "3",
      label: "Activity",
      children: <TabActivity />,
    },
  ];

  return (
    <Col flex="420px" className="right_area">
      <Tabs
        defaultActiveKey="1"
        items={GeneralDetailTabs}
        className="dashboard_tabs_cs"
      />
    </Col>
  );
}
